import React, { useState, useEffect, useRef } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import DialogLayout from "../../../../partials/content/DialogLayout";
import Illustration from "../../../../partials/content/Illustration";
import { uploadMassUploadData } from "../../../../services/commons";
import ConfirmUploadedMassUploadForm from "./confirmUploadedMassUploadForm";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { Formik } from "formik";
import * as yup from "yup";
import { CustomSelectField } from "../../../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import Swal from "sweetalert2";
import { DialogActions } from "@material-ui/core";
import { DropzoneAreaBase } from "material-ui-dropzone";
import { apiUrl } from "../../../../../config.js";
import { getFileExtension } from "../../../../utils/utils";
import { FileIcon, defaultStyles } from "react-file-icon";
import { SlideMenu } from "primereact/slidemenu";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function MassUpload({ match, history }) {
  const { reload } = useGlobalData();
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [uploadedMassUploads, setUploadedMassUploads] = useState([]);
  const [showUploadedMassUpload, setShowUploadedMassUpload] = useState(false);
  const [files, setFiles] = useState([]);
  const [appCode, setAppCode] = useState("CUST");
  const [appCodeDesc, setAppCodeDesc] = useState("Customer");
  const [massUploadData, setMassUploadData] = useState({
    ID: 0,
    massUploadFor: 0,
    appCode: "CUST",
    appCodeDesc: "Customer",
  });
  const menu = useRef(null);
  const menuItems = [
    {
      label: "Customer",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/CUST",
          "_blank"
        );
      },
    },
    {
      label: "Lead",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/LEAD",
          "_blank"
        );
      },
    },
    {
      label: "Outlet",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/OUTL",
          "_blank"
        );
      },
    },
    {
      label: "Warehouse",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/WARE",
          "_blank"
        );
      },
    },
    {
      label: "Item",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/ITEM",
          "_blank"
        );
      },
    },
    {
      label: "Vendor",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/VEND",
          "_blank"
        );
      },
    },
    {
      label: "User",
      icon: "fas fa-file-excel",
      command: () => {
        window.open(
          apiUrl + "/commons/download-mass-upload-template/USER",
          "_blank"
        );
      },
    },
  ];

  const handlePreviewIcon = (fileObject, classes) => {
    const { name } = fileObject.file;
    return (
      <div
        style={{
          WebkitFontSmoothing: "antialiased",
          width: "40px",
          margin: "auto",
        }}
      >
        <FileIcon
          extension={getFileExtension(name)}
          {...defaultStyles[`${getFileExtension(name)}`]}
          labelUppercase
        />
      </div>
    );
  };
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
  ];
  actionButtons.push({
    title: "Download Template",
    color: "info",
    icon: "fas fa-cloud-download-alt",
    onClick: (event) => {
      menu.current.toggle(event);
    },
  });
  actionButtons.push({
    title: "New Mass Upload",
    color: "primary",
    icon: "fas fa-plus-circle",
    onClick: () => {
      setFiles([]);
      handleRefreshUploadedMassUpload();
      setOpenUploadFile(true);
    },
  });

  useEffect(() => {}, [reload]);

  const massUploadFormSchema = yup.object().shape({
    ID: yup.number(),
    massUploadFor: yup.number().required("Mass Upload For is Required"),
  });

  return (
    <React.Fragment>
      <PageSubHeader
        title="Mass Upload"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/common/mass-upload",
            title: "Mass Upload",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <SlideMenu
        ref={menu}
        model={menuItems}
        popup
        viewportHeight={225}
        menuWidth={171}
      ></SlideMenu>
      <ContentLayout>
        {showUploadedMassUpload ? (
          <ConfirmUploadedMassUploadForm
            uploadedMassUploads={uploadedMassUploads}
            appCode={appCode}
            appCodeDesc={appCodeDesc}
            onOpenUploadFile={() => {
              setOpenUploadFile(true);
            }}
            onConfirmSave={(data) => {
              if (appCode === "CUST") {
                setUploadedMassUploads(data.uploadedCustomers);
              } else if (appCode === "LEAD") {
                setUploadedMassUploads(data.uploadedLeads);
              } else if (appCode === "OUTL") {
                setUploadedMassUploads(data.uploadedOutlets);
              } else if (appCode === "WARE") {
                setUploadedMassUploads(data.uploadedWarehouses);
              } else if (appCode === "ITEM") {
                setUploadedMassUploads(data.uploadedItems);
              } else if (appCode === "VEND") {
                setUploadedMassUploads(data.uploadedVendors);
              } else if (appCode === "USER") {
                setUploadedMassUploads(data.uploadedUsers);
              }
              setOpenUploadFile(false);
              setShowUploadedMassUpload(true);
            }}
            handleRefreshUploadedMassUpload={handleRefreshUploadedMassUpload}
            history={history}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Setup.png"
            description="Good Start! You're ready for Mass Upload!"
            guidance="Hint: upload master data based on template provided"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openUploadFile}
        title="Mass Upload Form"
        onCloseDialog={() => {
          setOpenUploadFile(false);
        }}
        maxWIdth="md"
      >
        <Formik
          initialValues={massUploadData}
          enableReinitialize={true}
          validationSchema={massUploadFormSchema}
          onSubmit={async (values, { setStatus, setSubmitting }) => {
            if (files.length === 1) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              })
                .fire({
                  title:
                    "Are you sure want to upload this file as " +
                    values.appCodeDesc +
                    " mass upload source?",
                  text:
                    "Please make sure all the input data is correct based on Invifo " +
                    values.appCodeDesc +
                    " upload template",
                  icon: "question",
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, upload it`,
                  cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                  reverseButtons: true,
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    const filesData = new FormData();
                    for (const file of files) {
                      filesData.append("files[]", file.file);
                    }
                    setFiles([]);
                    uploadMassUploadData(values.appCode, filesData).then(
                      (response) => {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Ready To Verified",
                          html: response.data.message,
                          icon: "info",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                        const { data } = response.data;
                        setFiles([]);
                        if (values.appCode === "CUST") {
                          setUploadedMassUploads(data.uploadCustomers);
                          setAppCode("CUST");
                          setAppCodeDesc("Customer");
                        } else if (values.appCode === "LEAD") {
                          setUploadedMassUploads(data.uploadLeads);
                          setAppCode("LEAD");
                          setAppCodeDesc("Lead");
                        } else if (values.appCode === "OUTL") {
                          setUploadedMassUploads(data.uploadOutlets);
                          setAppCode("OUTL");
                          setAppCodeDesc("Outlet");
                        } else if (values.appCode === "WARE") {
                          setUploadedMassUploads(data.uploadWarehouses);
                          setAppCode("WARE");
                          setAppCodeDesc("Warehouse");
                        } else if (values.appCode === "ITEM") {
                          setUploadedMassUploads(data.uploadItems);
                          setAppCode("ITEM");
                          setAppCodeDesc("Item");
                        } else if (values.appCode === "VEND") {
                          setUploadedMassUploads(data.uploadVendors);
                          setAppCode("VEND");
                          setAppCodeDesc("Vendor");
                        } else if (values.appCode === "USER") {
                          setUploadedMassUploads(data.uploadUsers);
                          setAppCode("USER");
                          setAppCodeDesc("User");
                        }
                        setOpenUploadFile(false);
                        setShowUploadedMassUpload(true);
                      }
                    );
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Cancelled",
                      text: "No change has been made",
                      icon: "info",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  }
                });
            } else {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text: "Please upload a file",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form
              noValidate={true}
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
              onKeyDown={onPreventEnterSubmitting}
            >
              <CustomSelectField
                label="Mass Upload For"
                propertyName="massUploadFor"
                onBlur={handleBlur}
                onChange={(e) => {
                  handleChange(e);
                  if (e.target.value === 0) {
                    setFieldValue("appCode", "CUST");
                    setFieldValue("appCodeDesc", "Customer");
                    setAppCode("CUST");
                    setAppCodeDesc("Customer");
                  } else if (e.target.value === 1) {
                    setFieldValue("appCode", "LEAD");
                    setFieldValue("appCodeDesc", "Lead");
                    setAppCode("LEAD");
                    setAppCodeDesc("Lead");
                  } else if (e.target.value === 2) {
                    setFieldValue("appCode", "OUTL");
                    setFieldValue("appCodeDesc", "Outlet");
                    setAppCode("OUTL");
                    setAppCodeDesc("Outlet");
                  } else if (e.target.value === 3) {
                    setFieldValue("appCode", "WARE");
                    setFieldValue("appCodeDesc", "Warehouse");
                    setAppCode("WARE");
                    setAppCodeDesc("Warehouse");
                  } else if (e.target.value === 4) {
                    setFieldValue("appCode", "ITEM");
                    setFieldValue("appCodeDesc", "Item");
                    setAppCode("ITEM");
                    setAppCodeDesc("Item");
                  } else if (e.target.value === 5) {
                    setFieldValue("appCode", "VEND");
                    setFieldValue("appCodeDesc", "Vendor");
                    setAppCode("VEND");
                    setAppCodeDesc("Vendor");
                  } else if (e.target.value === 6) {
                    setFieldValue("appCode", "USER");
                    setFieldValue("appCodeDesc", "User");
                    setAppCode("USER");
                    setAppCodeDesc("User");
                  }
                }}
                values={values}
                touched={touched}
                errors={errors}
                size="small"
                options={[
                  { label: "Customer", value: 0 },
                  { label: "Lead", value: 1 },
                  { label: "Outlet", value: 2 },
                  { label: "Warehouse", value: 3 },
                  { label: "Item", value: 4 },
                  { label: "Vendor", value: 5 },
                  { label: "User", value: 6 },
                ]}
              />
              <DropzoneAreaBase
                fileObjects={files}
                maxFileSize={10000000}
                filesLimit={1}
                acceptedFiles={[
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                ]}
                getPreviewIcon={handlePreviewIcon}
                onAdd={(newFile) => {
                  setFiles([].concat(files, newFile));
                }}
                onDelete={(deleteFile) => {
                  const fileList = [...files];
                  fileList.map((file, indexFile) => {
                    if (file.data === deleteFile.data) {
                      if (indexFile !== -1) {
                        fileList.splice(indexFile, 1);
                      }
                    }
                  });
                  setFiles(fileList);
                }}
                showPreviewsInDropzone={true}
                showFileNames={true}
                dropzoneText={`Drag and drop a file here or click. Please use ${values.appCodeDesc} mass upload template provided`}
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenUploadFile(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
                <a
                  href={
                    apiUrl +
                    "/commons/download-mass-upload-template/" +
                    values.appCode
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  <button
                    type="button"
                    className="btn btn-label-info btn-md btn-pill btn-bold"
                    onClick={() => {}}
                  >
                    <i className="fas fa-cloud-download-alt"></i>
                    Download {values.appCodeDesc} Template
                  </button>
                </a>
                <button
                  type="submit"
                  className="btn btn-success btn-md btn-pill btn-bold"
                  disabled={isSubmitting}
                >
                  <i className="fas fa-spell-check"></i>
                  Verify & Upload
                </button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogLayout>
    </React.Fragment>
  );

  async function handleRefreshUploadedMassUpload() {
    setUploadedMassUploads([]);
  }
}

export default MassUpload;
